import { render, staticRenderFns } from "./BSPD.vue?vue&type=template&id=e4b1915c&scoped=true&lang=pug"
import script from "./BSPD.vue?vue&type=script&lang=js"
export * from "./BSPD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b1915c",
  null
  
)

export default component.exports